import React from 'react'
import { useFormContext } from 'react-hook-form'
import { TransitOperationFormValues } from 'features/declaration/models/schemas/transitOperationFormSchema'
import TransportDocuments from 'features/declaration/form/components/TransportDocuments'
import PreviousDocuments from 'features/declaration/form/components/PreviousDocuments'
import SupportingDocuments from 'features/declaration/form/components/SupportingDocuments'
import {
  blankPreviousDocument, blankSupportingDocument, blankTransportDocument,
} from 'features/declaration/models/blankItems'
import DeclarationTabLayout from 'features/declaration/form/components/DeclarationTabLayout'
import GeneralSection from './GeneralSection'
import TransportSection from './TransportSection'
import PlaceOfLoading from './PlaceOfLoading'
import PlaceOfUnloading from './PlaceOfUnloading'
import CustomsOfficeOfTransit from './CustomsOfficeOfTransit'
import LocationOfGoods from './LocationOfGoods'
import Authorisations from './Authorisations'
import Guarantees from './Guarantees'
import CustomsOfficeOfExitForTransit from './CustomsOfficeOfExitForTransit'
import PlaceOfAcceptance from './PlaceOfAcceptance'
import PlaceOfDelivery from './PlaceOfDelivery'
import CountriesOfRouting from './CountriesOfRouting'
import ActiveBorderTransportMeans from './ActiveBorderTransportMeans'
import ConsignmentTransportEquipment from './ConsignmentTransportEquipment'
import DepartureTransportMeans from './DepartureTransportMeans'
import useDeclarationCountry from 'features/declaration/form/components/useDeclarationCountry'

function DeclarationGeneralTab() {
  const { getValues } = useFormContext<TransitOperationFormValues>()
  const inlandModeOfTransport = getValues('inlandModeOfTransport')
  const country = useDeclarationCountry()

  return (
    <DeclarationTabLayout
      start={(
        <>
          <GeneralSection />
          <Guarantees />
          <CountriesOfRouting />
        </>
      )}
      centerLeft={(
        <>
          <TransportSection isEnsMode={false} />
          <DepartureTransportMeans inlandModeOfTransport={inlandModeOfTransport} />
          <ActiveBorderTransportMeans />
        </>
      )}
      centerRight={(
        <>
          <PlaceOfLoading />
          <PlaceOfUnloading />
          <Authorisations />
          <TransportDocuments<TransitOperationFormValues>
            scope="transitOperation"
            createDefault={() => blankTransportDocument}
            isEns={false}
            country={country}
          />
          <PreviousDocuments<TransitOperationFormValues>
            scope="transitOperation"
            createDefault={() => blankPreviousDocument}
            country={country}
          />
          <SupportingDocuments<TransitOperationFormValues>
            scope="transitOperation"
            createDefault={() => blankSupportingDocument}
            isEns={false}
            country={country}
          />
        </>
      )}
      end={(
        <>
          <PlaceOfAcceptance />
          <PlaceOfDelivery />
          <ConsignmentTransportEquipment />
          <CustomsOfficeOfTransit />
          <CustomsOfficeOfExitForTransit />
          <LocationOfGoods />
        </>
      )}
    />
  )
}

export default DeclarationGeneralTab
